<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="sale-person content-wrapper">
      <div class="page-header">{{ $t('newSalePerson') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingSalePersonList' }">{{ $t('salePerson') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newSalePerson') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('firstName')" :required="true">
          <el-input v-model="salePerson.firstName" class="input-with-select">
            <el-select v-model="salePerson.title" slot="prepend" placeholder="Title" style="width: 85px">
              <el-option label="Mr." value="Mr."></el-option>
              <el-option label="Mrs." value="Mrs."></el-option>
              <el-option label="Miss." value="Miss."></el-option>
              <el-option label="Ms." value="Ms."></el-option>
              <el-option label="Other" value=" "></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lastName')">
          <el-input v-model="salePerson.lastName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('position')">
          <el-input v-model="salePerson.position"></el-input>
        </el-form-item>
        <el-form-item :label="$t('phone')">
          <el-input v-model="salePerson.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mobile')" :required="true">
          <el-input v-model="salePerson.mobile"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fax')">
          <el-input v-model="salePerson.fax"></el-input>
        </el-form-item>
        <el-form-item :label="$t('email')" :required="true">
          <el-input v-model="salePerson.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('signature')">
          <div class="image-preview" v-if="imageData !== ''">
            <div style="width: fit-content">
              <font-awesome-icon icon="times-circle" class="remove-signature-icon" @click="removeSignature"/>
              <img class="preview" width="150px" :src="imageData">
            </div>
          </div>
          <div class="file-upload-form">
            <input type="file" @change="getBase64Image" accept="image/*">
          </div>
          <div>
            <small class="text-remark">{{ $t('remarkImageSize') }}</small>
          </div>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 500px; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onCreateSalePersonButtonClick">{{ $t('createSalePerson') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/SalePerson/Add.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingSalePersonApi from '@/api/setting/sale-person-api'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faTimesCircle)

export default {
  name: 'SettingSalePersonAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, FontAwesomeIcon },
  i18n: { messages: i18nMessages },
  data () {
    return {
      isLoading: false,
      imageData: '',
      salePerson: {
        title: 'Mr.',
        firstName: '',
        lastName: '',
        position: '',
        phone: '',
        mobile: '',
        fax: '',
        email: '',
        signatureImage: ''
      }
    }
  },
  methods: {
    onCreateSalePersonButtonClick: async function () {
      try {
        this.startLoading()

        let imageData = {}

        if (this.imageData !== '') {
          imageData = {
            signatureImage: this.imageData
          }
        }

        const salePersonData = Object.assign({}, this.salePerson, imageData)
        await SettingSalePersonApi.create(salePersonData)

        const title = this.$t('createSalePersonSuccessTitle')
        const message = this.$t('createSalePersonSuccessMessage')
        this.showNotificationSuccess(title, message)

        this.$router.push({
          name: 'SettingSalePersonList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingSalePersonList'
      })
    },
    removeSignature: function () {
      this.imageData = ''
    },
    getBase64Image: function (event) {
      const input = event.target
      const MAX_IMAGE_SIZE = 1048576

      if (input.files && input.files[0]) {
        if (input.files[0].size > MAX_IMAGE_SIZE) {
          input.value = ''
          this.alertError(this.$t('imageSizeOverMessage'))

          return false
        }

        const reader = new FileReader()

        reader.onload = (e) => {
          this.imageData = e.target.result
        }

        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>

<style scoped>
  .remove-signature-icon {
    cursor: pointer;
    position: relative;
    color: #dd3333;
    font-size: 20px;
    float: right;
    right: 10px;
    top: -10px;
    background: #ffffff;
    border-radius: 10px;
  }

  .text-remark {
    color: #F56C6C;
  }

  .el-form > div {
    text-align: left;
  }
</style>
